import graphqlClient from '@/graphql/graphql-client';
import { toScalarListVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  GetUilmTranslationJobsDocument,
  type GetUilmTranslationJobsQuery,
} from '@/graphql/generated/graphql';

export type UilmTranslationJobRecord = NonNullable<
  NonNullable<GetUilmTranslationJobsQuery['getUilmTranslationJobs']>['items']
>[number];
export type GetUilmTranslationJobsResponse = GetUilmTranslationJobsQuery;

export const useGetUilmTranslationJobs = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toScalarListVariables(params, { templateId: 'TemplateId' });
  return useQuery({
    queryKey: ['uilm-translation-jobs', variables],
    queryFn: () => graphqlClient.request(GetUilmTranslationJobsDocument, variables),
  });
};

export const requestUilmTranslationJobs = (
  params?: ListQueryVariables<Record<string, unknown>>
) => {
  const variables = toScalarListVariables(params, { templateId: 'TemplateId' });
  return graphqlClient.request(GetUilmTranslationJobsDocument, variables);
};

export const GET_UILM_TRANSLATION_JOBS_QUERY = GetUilmTranslationJobsDocument;
